
import { acnocDashboardTypes } from '../acReduxExports';

const nocDashboarInitialState: AcNOCDashboardState = {
    latestChargerDetails:null,
    latestChargerAlarmDetails:null,
    latestChargerSearchHash:null,
    nocDashboardChargerSessionVolumeSearchHash:null,
    nocDashboardChargerSessionVolumeFilterHash:null,
    nocDashboardChargerAlarmSearchHash:null,
    nocDashboardChargerAlarmFilterHash:null,
    nocDashboardChargerUptimeFilterHash:null,
    nocDashboardChargerUptimeSearchHash:null,
    latestChargerFilterRequestHash:null,
    latestChargerDetailsLoader: false,
    nocDashboardChargerList: null,
    nocDashboardLatestAlarmCharger: null,
    nocDashboardChargerListLoader:false,
    nocDashboardChargerSummaryLoader:false,
    nocDashboardChargerAlarmLoader:false,
    nocDashboardChargerUptimeLoader:false,
    nocDashboardChargerPerfomanceRankingsLoader:false,
    nocDashboardChargerPerformanceLoader:false,
    nocDashboardChargerSessionVolumeLoader:false,
    nocDashboardChargerPerfomanceRankingFilterHash:null,
    nocDashboardChargerPerfomanceFilterHash:null,
    nocDashboardSearchHash: null,
    nocDashboardFilterRequestHash:null,
    nocDashboardAlertsCount:null,
    nocDashboardAlertsCountLoader:null,
    nocDashboardAlertsList:null,
    nocDashboardAlertsListLoader:false,
    nocDashboardAlertsListFilterRequestHash:null,
    nocDashboardAlertsListSearchHash:null,
    nocDashboardChargerPerfomanceRankingSearchHash:null,
    nocDashboardChargerPerfomanceSearchHash:null,
    nocDashboardFlagAlertResponse:false,
    nocDashboardAlarmsPlotData: null,
    nocDashboardChargerUptimeData:null,
     nocDashboardChargerAlarmData:  null,
    nocDashboardChargingSessionsPlotData: null,
    nocDashboardChargerUptimePlotData: null,
    nocDashboardConsumedEnergyPlotData: null,
    nocDashboardConnectorStatusData: null,
    nocDashboardChargerPerfomanceData:null,
    nocDashboardChargerPerfomanceRankingsData:null,
    nocDashboardChargerEfficiencyPerfomanceRankingsData:null,
    nocDashboardChargerUptimePerfomanceRankingsData:null,
    nocDashboardChargerUtilisationPerfomanceRankingsData:null,
    nocDashboardChargerSessionPerfomanceData:null,
    nocDashbaordChargerSessionVolumeData:null,
    nocDashboardChargerAnalyticsLoader:false,
    nocDashboardChargerAnalyticsSearchHash: null,
    nocDashboardChargerAnalyticsFilterRequestHash: null,
    nocDashboardChargerSummaryFilterRequestHash:null,
    nocDashboardChargerSummarySearchHash:null,
    nocDashboardMapCenterCoordinates: null,
    nocDashboardAlarmCounts:null,
    nocDashboardChargerIdsForRedirection: null,
    nocDashboardActiveTab: 'liveTopologyMap'
}


const  acnocDashboardReducer = (
    state: NOCDashboardState = nocDashboarInitialState,
    action: NOCDashboardAction
): NOCDashboardState => {
    switch(action.type) {
        case acnocDashboardTypes.SET_AC_LATEST_CHARGER_DETAILS_LOADER:
            return {
                ...state,
                latestChargerDetailsLoader: action.latestChargerDetailsLoader || false
            }
        case acnocDashboardTypes.SET_AC_LATEST_CHARGER_DETAILS_REQUEST_HASH:
            return {
                ...state,
                latestChargerSearchHash: action.latestChargerSearchHash,
                latestChargerFilterRequestHash: action.latestChargerFilterRequestHash
            }
        case acnocDashboardTypes.FETCH_AC_LATEST_CHARGER_DETAILS:
            return {
                ...state,
                latestChargerDetails: action.latestChargerDetails,
                latestChargerAlarmDetails: action.latestChargerAlarmDetails
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_LIST_LOADER:
            return {
                ...state,
                nocDashboardChargerListLoader: action.nocDashboardChargerListLoader
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_LIST_REQUEST_HASH:
            return {
                ...state,
                nocDashboardSearchHash:action.nocDashboardSearchHash,
                nocDashboardFilterRequestHash: action.nocDashboardFilterRequestHash
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_LIST:
            return {
                ...state,
                nocDashboardChargerList: action.nocDashboardChargerList,
                nocDashboardLatestAlarmCharger: action.nocDashboardLatestAlarmCharger,
                nocDashboardMapCenterCoordinates: action.nocDashboardMapCenterCoordinates,
                nocDashboardAlarmCounts:action.nocDashboardAlarmCounts
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_ALERT_COUNT_LOADER:
            return {
                ...state,
                nocDashboardAlertsCountLoader:action.nocDashboardAlertsCountLoader
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_ALERT_COUNT:
            return{
                ...state,
                nocDashboardAlertsCount:action.nocDashboardAlertsCount
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_ALERTS_LIST:
            return{
                ...state,
                nocDashboardAlertsList:action.nocDashboardAlertsList
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_FLAG_ALERT:
            return{
                ...state,
                nocDashboardFlagAlertResponse:action.nocDashboardFlagAlertResponse
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_ANALYTICS_DATA:
            return {
                ...state,
                nocDashboardConnectorStatusData: action.nocDashboardConnectorStatusData,
                nocDashboardAlarmsPlotData: action.nocDashboardAlarmsPlotData,
                nocDashboardChargingSessionsPlotData: action.nocDashboardChargingSessionsPlotData,
                nocDashboardChargerUptimePlotData: action.nocDashboardChargerUptimePlotData,
                nocDashboardConsumedEnergyPlotData: action.nocDashboardConsumedEnergyPlotData,
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_SUMMARY_DATA:
            return {
                ...state,
                nocDashboardChargerPerfomanceData:action.nocDashboardChargerPerfomanceData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_PERFOMANCE_RANKINGS_DATA:
            return {
                ...state,
                nocDashboardChargerPerfomanceRankingsData:action.nocDashboardChargerPerfomanceRankingsData
               
            }
         case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_UPTIME_PERFOMANCE_RANKINGS_DATA:
            return {
                ...state,
                nocDashboardChargerUptimePerfomanceRankingsData:action.nocDashboardChargerUptimePerfomanceRankingsData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_UTILISATION_PERFOMANCE_RANKINGS_DATA:
            return {
                ...state,
                nocDashboardChargerUtilisationPerfomanceRankingsData:action.nocDashboardChargerUtilisationPerfomanceRankingsData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_EFFICIENCY_PERFOMANCE_RANKINGS_DATA:
            return {
                ...state,
                nocDashboardChargerEfficiencyPerfomanceRankingsData:action.nocDashboardChargerEfficiencyPerfomanceRankingsData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_PERFOMANCE_DATA:
            return {
                ...state,
               nocDashboardChargerSessionPerfomanceData: action.nocDashboardChargerSessionPerfomanceData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_DATA:
            return {
                ...state,
               nocDashbaordChargerSessionVolumeData: action.nocDashbaordChargerSessionVolumeData
               
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_UPTIME_DATA:
            return {
                ...state,
               nocDashboardChargerUptimeData: action.nocDashboardChargerUptimeData
            }
        case acnocDashboardTypes.FETCH_AC_NOC_DASHBOARD_CHARGER_ALARM_DATA:
            return {
                ...state,
               nocDashboardChargerAlarmData: action.nocDashboardChargerAlarmData
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_ANALYTICS_LOADER:
            return {
                ...state,
                nocDashboardChargerAnalyticsLoader: action.nocDashboardChargerAnalyticsLoader || false
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_SUMMARY_LOADER:
            return {
                ...state,
                nocDashboardChargerSummaryLoader: action.nocDashboardChargerSummaryLoader || false
            }
         case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_PERFORMANCE_RANKINGS_LOADER:
            return {
                ...state,
                nocDashboardChargerPerfomanceRankingsLoader: action.nocDashboardChargerPerfomanceRankingsLoader || false
            }
         case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_PERFORMANCE_LOADER:
            return {
                ...state,
                nocDashboardChargerPerformanceLoader: action.nocDashboardChargerPerformanceLoader || false
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_LOADER:
            return {
                ...state,
                nocDashboardChargerSessionVolumeLoader: action.nocDashboardChargerSessionVolumeLoader || false
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_UPTIME_LOADER:
            return {
                ...state,
                nocDashboardChargerUptimeLoader: action.nocDashboardChargerUptimeLoader || false
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_ALARM_LOADER:
            return {
                ...state,
                nocDashboardChargerAlarmLoader: action.nocDashboardChargerAlarmLoader || false
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_ANALYTICS_REQUEST_HASH:
            return {
                ...state,
                nocDashboardChargerAnalyticsSearchHash: action.nocDashboardChargerAnalyticsSearchHash,
                nocDashboardChargerAnalyticsFilterRequestHash: action.nocDashboardChargerAnalyticsFilterRequestHash
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_SUMMARY_REQUEST_HASH:
            return {
                ...state,
                nocDashboardChargerSummarySearchHash: action.nocDashboardChargerSummarySearchHash,
                nocDashboardChargerSummaryFilterRequestHash: action.nocDashboardChargerSummaryFilterRequestHash
            }
         case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_PERFOMANCE_RANKINGS_REQUEST_HASH:
            return {
                ...state,
               nocDashboardChargerPerfomanceRankingSearchHash : action.nocDashboardChargerPerfomanceRankingSearchHash,
               nocDashboardChargerPerfomanceRankingFilterHash: action.nocDashboardChargerPerfomanceRankingFilterHash
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_PERFOMANCE_REQUEST_HASH:
            return {
                ...state,
               nocDashboardChargerPerfomanceSearchHash : action.nocDashboardChargerPerfomanceSearchHash,
               nocDashboardChargerPerfomanceFilterHash: action.nocDashboardChargerPerfomanceFilterHash
            }
         case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_REQUEST_HASH:
            return {
                ...state,
               nocDashboardChargerSessionVolumeSearchHash : action.nocDashboardChargerSessionVolumeSearchHash,
               nocDashboardChargerSessionVolumeFilterHash: action.nocDashboardChargerSessionVolumeFilterHash
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_UPTIME_REQUEST_HASH:
            return {
                ...state,
               nocDashboardChargerUptimeSearchHash : action.nocDashboardChargerUptimeSearchHash,
               nocDashboardChargerUptimeFilterHash: action.nocDashboardChargerUptimeFilterHash
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_ALARM_REQUEST_HASH:
            return {
                ...state,
               nocDashboardChargerAlarmSearchHash : action.nocDashboardChargerAlarmSearchHash,
               nocDashboardChargerAlarmFilterHash: action.nocDashboardChargerAlarmFilterHash
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_CHARGER_IDS_FOR_REDIRECTION:
            return {
                ...state,
                nocDashboardChargerIdsForRedirection: action.nocDashboardChargerIdsForRedirection
            }
        case acnocDashboardTypes.SET_AC_NOC_DASHBOARD_ACTIVE_TAB:
            return {
                ...state,
                nocDashboardActiveTab: action.nocDashboardActiveTab
            }
        default:
            return state;
    }
}


export default acnocDashboardReducer;